import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as AdsAudienceMembershipActionMetadataKeys from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadataKeys';
export default class AdsAudienceMembershipActionMetadata extends Record({
  [AdsAudienceMembershipActionMetadataKeys.ACTION_TYPE]: ActionTypes.ADS_AUDIENCE_MEMBERSHIP,
  [AdsAudienceMembershipActionMetadataKeys.SHOULD_ADD]: null,
  [AdsAudienceMembershipActionMetadataKeys.AUDIENCE_ID]: null
}, 'AdsAudienceMembershipActionMetadata') {}